import React from 'react';

// Static data for payment failure details
const paymentFailureDetails = {
  reasons: [
    "Insufficient funds in your account.",
    "Incorrect payment details entered.",
    "Technical issues with the payment gateway.",
    "Your bank may have blocked the transaction for security reasons."
  ],
  steps: [
    { step: "Step 1", description: "Verify that all payment information is correct." },
    { step: "Step 2", description: "Ensure that you have sufficient funds or credit available." },
    { step: "Step 3", description: "Try using a different payment method if possible." },
    { step: "Step 4", description: "Contact your bank or payment provider for assistance." }
  ],
  supportEmail: "support@siddhicreatives.com",
  returnLink: "/"
};

const PaymentFailure = React.memo(() => {
  return (
    <div className="max-w-6xl mx-auto my-10 p-5 bg-white shadow-md rounded-lg mt-20">
      <h1 className="text-3xl font-bold text-center mb-6">Payment Failed</h1>

      <div className="flex flex-col gap-3 py-5 pl-2 sm:pl-6 overflow-hidden">
        <div className="flex flex-col gap-5 items-start w-full">
          <h2 className="text-xl font-bold">We're Sorry!</h2>
          <p className="text-gray-700">
            Unfortunately, your payment could not be processed at this time. We understand how frustrating this can be, and we are here to help you resolve the issue.
          </p>

          <h3 className="text-lg font-semibold mt-4">Possible Reasons for Payment Failure</h3>
          <ul className="list-disc list-inside text-gray-700">
            {paymentFailureDetails.reasons.map((reason, index) => (
              <li key={index}>{reason}</li>
            ))}
          </ul>

          <h3 className="text-lg font-semibold mt-4">What You Can Do</h3>
          <p className="text-gray-700">
            Please check your payment details and try again. If you continue to experience issues, here are some steps you can take:
          </p>
          <ul className="list-disc list-inside text-gray-700">
            {paymentFailureDetails.steps.map((step, index) => (
              <li key={index}>
                <strong>{step.step}:</strong> {step.description}
              </li>
            ))}
          </ul>

          <h3 className="text-lg font-semibold mt-4">Need Assistance?</h3>
          <p className="text-gray-700">
            If you need further help, please reach out to our customer service team:
            <br />
            <strong>Email:</strong>{" "}
            <a href={`mailto:${paymentFailureDetails.supportEmail}`} className="text-blue-500 hover:underline">
              {paymentFailureDetails.supportEmail}
            </a>
          </p>

          <h3 className="text-lg font-semibold mt-4">Return to Shopping</h3>
          <p className="text-gray-700">
            You can return to our store and continue shopping for your favorite items.
          </p>

          <div className="mt-5">
            <a href={paymentFailureDetails.returnLink} className="px-6 py-3 bg-primary-blue  uppercase shadow hover:shadow-lg text-white transition duration-300 ease-in-out">
              Continue Shopping
            </a>
          </div>
        </div>
      </div>
    </div>
  );
});

export default PaymentFailure;
